import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { LanguageProvider } from "@/i18n/LanguageContext";
import PublicLayout from "@/components/PublicLayout";
import AdminLayout from "@/components/AdminLayout";
import ProtectedRoute from "@/components/ProtectedRoute";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Home from "@/pages/Home";
import Promo from "@/pages/Promo";
import Collections from "@/pages/Collections";
import ProductDetail from "@/pages/ProductDetail";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import NotFound from "@/pages/NotFound";

import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminCategories from "@/pages/admin/AdminCategories";
import AdminProducts from "@/pages/admin/AdminProducts";
import AdminInquiries from "@/pages/admin/AdminInquiries";
import AdminTrash from "@/pages/admin/AdminTrash";
import AdminHomepage from "@/pages/admin/AdminHomepage";



function ScrollToTop() {
  const { pathname } = useLocation();
  const prevPath = useRef(pathname);
  useEffect(() => {
    // Switching category tabs inside the catalog keeps the scroll position;
    // every other navigation starts at the top.
    const isCatalogTab = (p) => p === "/collections" || /^\/collections\/[^/]+$/.test(p);
    const keepScroll = isCatalogTab(prevPath.current) && isCatalogTab(pathname);
    prevPath.current = pathname;
    if (!keepScroll) window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}


function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <BrowserRouter>
        <ScrollToTop />
        <Routes>
          {/* Public */}
          <Route element={<PublicLayout />}>
            <Route path="/" element={<Home />} />
            <Route path="/promo" element={<Promo />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/collections/:slug" element={<Collections />} />
            <Route path="/product/:id" element={<ProductDetail />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/collections/:categorySlug/:productSlug" element={<ProductDetail />} />
          </Route>

          {/* Admin login (no layout) */}
          <Route path="/admin/login" element={<AdminLogin />} />

          {/* Admin protected */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminDashboard />} />
            <Route path="homepage" element={<AdminHomepage />} />
            <Route path="categories" element={<AdminCategories />} />
            <Route path="products" element={<AdminProducts />} />
            <Route path="inquiries" element={<AdminInquiries />} />
            <Route path="trash" element={<AdminTrash />} />
          </Route>

          <Route path="*" element={<NotFound />} />
        </Routes>
        <Toaster
          theme="dark"
          position="bottom-right"
          toastOptions={{
            style: {
              background: "#1A1A1A",
              border: "1px solid rgba(244,240,234,0.12)",
              color: "#F4F0EA",
              borderRadius: 0,
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
      </BrowserRouter>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
